<template>
  <auth-layout pageClass="login-page">
    <div class="row d-flex justify-content-center align-items-center">
      <div class="col-lg-4 col-md-6 col-sm-8">
        <div class="row" v-if="loadingLogin" v-loading="loadingLogin" id="loading">
        </div>
        <form v-if="!loadingLogin" @submit.prevent="login" method="post">
          <!--You can specify transitions on initial render. The `card-hidden` class will be present initially and then it will be removed-->
          <fade-render-transition>
            <card>
              <div slot="header">
                <h3 class="card-title text-center">Área do Aluno</h3>
              </div>
              <div>
                <fg-input label="Endereço de E-mail:"
                          placeholder="Entre com seu email"
                          type="email"
                          v-model="model.email">

                </fg-input>
                <fg-input label="Senha:"
                          type="password"
                          placeholder="Entre com sua senha"
                          v-model="model.password">
                </fg-input>
              </div>
              <div class="alert alert-danger" v-if="loginError">
                {{loginMessage}}
              </div>
              <div class="text-center">
                <button type="submit" class="btn btn-fill btn-info btn-round btn-wd ">Entrar</button>
                <br>
                <div class="forgot">
                  <a href="https://api.aluno.top-trader.org/password/reset" target="_blank">Esqueceu sua senha? Recupere aqui</a>
                  <br />
                  <router-link to="registeruser" target="_blank">Ainda não é aluno? Registre-se aqui</router-link>
                </div>
              </div>
            </card>
          </fade-render-transition>

        </form>
      </div>
    </div>
  </auth-layout>
</template>
<script>
  import { Checkbox as LCheckbox, FadeRenderTransition } from 'src/components/index'
  import AuthLayout from './AuthLayout.vue'
  export default {
    components: {
      LCheckbox,
      FadeRenderTransition,
      AuthLayout
    },
    data () {
      return {
        loginError: false,
        loginMessage: '',
        loadingLogin: false,
        model: {
          email: '',
          password: '',
          subscribe: true
        }
      }
    },
    methods: {
      login(){
        var app = this
        app.loadingLogin = true;
        this.$auth.login({
          data: {
            email: app.model.email,
            password: app.model.password
          },
          success: function (response) {
            app.loadingLogin = false;
          },
          error: function (error) {
            app.loadingLogin = false;
            app.loginError = true;
            app.loginMessage = JSON.parse(JSON.stringify(error)).response.data.msg;
          },
          rememberMe: true,
          redirect: '/dashboard',
          fetchUser: true,
        });
      },
      toggleNavbar () {
        document.body.classList.toggle('nav-open')
      },
      closeMenu () {
        document.body.classList.remove('nav-open')
        document.body.classList.remove('off-canvas-sidebar')
      }
    },
    beforeDestroy () {
      this.closeMenu()
    }
  }
</script>
<style>
  .navbar-nav .nav-item p{
    line-height: inherit;
    margin-left: 5px;
  }
</style>
<style>
  #loading {
      min-height: 200px;
      display: flex;
      align-items: center;
  .el-loading-spinner .path {
        stroke: #000 !important;
      }

      .el-loading-mask {
        background: transparent !important;
    }
  }

  .el-dialog {
    width: 50%;
  }
  @media (max-width: 800px){
    .el-dialog{
      width: 90%
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/Login.vue